import { inject } from '@angular/core';
import { AuthService } from '../auth.service';

export const AuthGuard = () => {
	const { isAuthenticated, navigateToPortal } = inject(AuthService);
	if (!isAuthenticated) navigateToPortal();
	return isAuthenticated;
};
